const ERROR_MESSAGE: any = {
  UNHANDLED_EXCEPTION: 'Something went wrong. Please contact Administrator.',
  ERROR_FILE_UPLOAD: 'Image file is too large. Please use a smaller image.',
  FIELD_REQUIRED: 'This is field required.',
  EMAIL_INVALID: 'Invalid email address.',
  PASSWORD_INVALID: 'Invalid password.',
  CHARACTER_PASSWORD: 'Password must contain at least 8 characters',
  CONFIRM_PASSWORD: 'Confirm Password does not match',
  SPECIAL_SYMBOL: 'Password contains at least 1 special symbol',
  ArticleNotExist: 'Article Does Not Exist',
  ArticleIsUnderReview:
    'This action cannot be performed. The topic is currently awaiting approval during a review period.',
  SlugUrlExisted: 'The Slug Url already exists, please use the different url to setup',
  TURTORIAL_TEXT: 'Please select the value for at least one of the 2 fields: User, Group User.',
  NotHavePermissionApprove: 'You do not have permission to approve',
  NotHavePermissionSubmit: 'You do not have permission to submit',
};
export default ERROR_MESSAGE;
